import {observer} from "mobx-react";
import * as React from "react";
import {UIState} from "data/UIState";
import {Login} from "components/Login";
import {Signup} from "components/signup/Signup";
import {Nav} from "components/nav/Nav";
import {FeedLandingPage} from "components/FeedLandingPage";
import {RewardsPage} from "components/RewardsPage";
import {MyWellnessPage} from "components/mywellness/MyWellnessPage";
import {CounselingPage} from "components/static-pages/Counseling";
import {LibraryPage} from "components/LibraryPage";
import {VitabotPage} from "components/static-pages/Vitabot";
import {ShopWellPage} from "components/static-pages/ShopWell";
import {FoodSwitchPage} from "components/static-pages/FoodSwitch";
import {CalmPage} from "components/static-pages/Calm";
import {HeadspacePage} from "components/static-pages/Headspace";
import {MyCoachingPage} from "components/static-pages/MyCoaching";
import {BiometricsPage} from "components/static-pages/Biometrics";
import {BoothPage} from "components/booth/BoothPage";
import {MainStageEventPage} from "components/mainstage/MainStageEventPage";
import {MainStageQuestionsPage} from "components/mainstage/MainStageQuestionsPage";
import {CustomLandingPage} from "components/static-pages/CustomLandingPage";
import {PageEnum, PageEnums} from "components/nav/PageEnums";
import {Dashboard} from "components/dashboard/Dashboard";
import dashboardData from "../data/DashboardData";
import {SolutionDetail} from "./SolutionDetailPage";
import {Account} from "components/account/Account";
import {SolutionRegister} from "./SolutionRegister";
import * as theme from '../theme.js';
import {LocationPage} from "./signup/LocationPage";

import './PageSwitcher.pcss';
import {BadgeHistory} from "components/badges/BadgeHistory";
import {HRApp} from "components/hr/HRApp";
import {SSOPanel} from "components/login/SSOPanel";
import {PlatformNotOpenYet} from "components/login/PlatformNotOpenYet";
import {PlatformClosed} from "components/login/PlatformClosed";
import {PlatformLoading} from "components/login/PlatformLoading";

interface Props {
}

@observer
export class PageSwitcher extends React.Component<Props> {


  render() {

    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = theme.BodyBGLevel0;

    if(PageEnums.loading.is(UIState.currentPage)){
      return <PlatformLoading />;
    } else if(UIState.settings.PLATFORM_CLOSED) {
      return <PlatformClosed />;
    } else if(!UIState.settings.PLATFORM_OPEN_FOR_REG) {
      return <PlatformNotOpenYet />;
    } else if (PageEnums.login.is(UIState.currentPage)) {
      return <Login />;
      // if(UIState.settings.ENABLE_SAML_SSO) {
      //   return <SSOPanel />;
      // } else {
      //   return <Login />;
      // }
    } else if (PageEnums.register.is(UIState.currentPage)) {
      return <Signup />;
    }


    /*
      // REGISTRATION AND SIGN IN
    else if (!UIState.user || PageEnums.register.is(UIState.currentPage)) {
      if(UIState.settings.ENABLE_SAML_SSO) {
        return (
          <div className={'sso-panel'}>
            <WellnessConceptsLogo />
            <div className={'sso-panel-card'}>
              <h1>Sign in with your company account</h1>
              <p><strong>{UIState.settings.COMPANY_NAME}</strong> is using the Wellness Concepts Platform to offer
                engaging wellness content. The platform is a central hub for participation, points, and badges.</p>
              <a className='cta-button noselect' href={'/saml/login'}>Continue</a>
            </div>
          </div>
        );
      }
      else if (!UIState.settings.PLATFORM_OPEN || UIState.currentPage.is(PageEnums.register) ) {
        return <Signup />; }
      else { return <Login />; }
    }
    */


    // Not yet open, but a user has been created or still in signup process
    //else if(!UIState.settings.PLATFORM_OPEN || UIState.signupInProgress) {
    else if(UIState.signupInProgress) {
      //return <Signup />;
      return <Login />;
    }

    // TERMS IF NOT AGREED YET
    else if (!UIState.user.agreedToTerms && UIState.settings.ENABLE_GDPR) {
      // return <TermsPage />;
      return <Signup />;
    }

    // NEED A LOCATION
    else if (!UIState.user._location && UIState.settings.LOCATIONS && UIState.settings.LOCATIONS.length>0) { return <LocationPage />; }

    // // Platform is not open
    // else if (!UIState.settings.PLATFORM_OPEN) { return <Login />; }

    // Load the Portal
    else {
      if (PageEnums.dashboard.is(UIState.currentPage)) {
        document.body.style.backgroundImage = `url('${UIState.settings.BG}')`;
        return <Dashboard/>;
      } else {

        document.body.style.backgroundImage = '';
        document.body.style.backgroundColor = theme.BodyBGLevel2;
        const nav = <Nav user={UIState.user}/>;
        //if (PageEnums.dashboard.is(UIState.currentPage)) { return <Dashboard />; }
        if (PageEnums.solutionDetail.is(UIState.currentPage)) {
          return <SolutionDetail dashboardSolution={dashboardData.selectedDashboardSolution}/>;
        } else if (PageEnums.solutionRegister.is(UIState.currentPage)) {
          return <SolutionRegister dashboardSolution={dashboardData.selectedDashboardSolution}/>;
        } else if (PageEnums.profile.is(UIState.currentPage)) {
          return <Account/>;
        } else if (PageEnums.hr.is(UIState.currentPage)) {
          return <HRApp />;
        } else if (PageEnums.badgeHistory.is(UIState.currentPage)) {
          return <BadgeHistory />;
        } else if (PageEnums.feedLandingPage.is(UIState.currentPage)) {
          return <FeedLandingPage nav={nav}/>;
        } else if (PageEnums.prizes.is(UIState.currentPage)) {
          return <RewardsPage nav={nav}/>;
        } else if (PageEnums.library.is(UIState.currentPage)) {
          return <LibraryPage searchText="" nav={nav}/>;
        } else if (PageEnums.booth.is(UIState.currentPage)) {
          return <BoothPage pageEnum={PageEnums.booth} nav={nav}/>;
        } else if (PageEnums.myWellness.is(UIState.currentPage)) {
          return <MyWellnessPage nav={nav}/>;
        } else if (PageEnums.counseling.is(UIState.currentPage)) {
          return <CounselingPage pageEnum={PageEnums.counseling} nav={nav}/>;
        } else if (PageEnums.vitabot.is(UIState.currentPage)) {
          return <VitabotPage pageEnum={PageEnums.vitabot} nav={nav}/>;
        } else if (PageEnums.shopwell.is(UIState.currentPage)) {
          return <ShopWellPage pageEnum={PageEnums.shopwell} nav={nav}/>;
        } else if (PageEnums.foodswitch.is(UIState.currentPage)) {
          return <FoodSwitchPage pageEnum={PageEnums.foodswitch} nav={nav}/>;
        } else if (PageEnums.calm.is(UIState.currentPage)) {
          return <CalmPage pageEnum={PageEnums.calm} nav={nav}/>;
        } else if (PageEnums.headspace.is(UIState.currentPage)) {
          return <HeadspacePage pageEnum={PageEnums.headspace} nav={nav}/>;
        } else if (PageEnums.quitnow.is(UIState.currentPage)) {
          return <HeadspacePage pageEnum={PageEnums.quitnow} nav={nav}/>;
        } else if (PageEnums.myCoaching.is(UIState.currentPage)) {
          return <MyCoachingPage pageEnum={PageEnums.myCoaching} nav={nav}/>;
        } else if (PageEnums.biometrics.is(UIState.currentPage)) {
          return <BiometricsPage pageEnum={PageEnums.biometrics} nav={nav}/>;
        } else if (PageEnums.mainstage.is(UIState.currentPage)) {
          return <MainStageEventPage pageEnum={PageEnums.mainstage} nav={nav}/>;
        } else if (PageEnums.mainstageQuestions.is(UIState.currentPage)) {
          return <MainStageQuestionsPage pageEnum={PageEnums.mainstageQuestions} nav={nav}/>;
        } else if (PageEnums.custom.is(UIState.currentPage)) {
          const pageEnum = new PageEnum(PageEnums.custom.name, UIState.currentCustomPage.title);
          return <CustomLandingPage pageEnum={pageEnum} nav={nav}/>;
        } else {
          return null;
        }
      }
    }
  }
}


